import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";



const SubUserTableRow = ({ tableKeysHelper, setFieldFilter, fieldToOrder, orderAscending  }) => {
    const { getTextByKey } = useContent();

    return (
        <>
            {
            tableKeysHelper.map((item, index) => {
                return (
                    <div className={`sub-user-table-desktop-header-item ${item.text}`} key={index}> 
                        {
                            (item.text !== "table-header-actions") && (
                                <div className="sub-user-table-desktop-header-item-text">
                                    {getTextByKey(item.text)}
                                </div>
                            )
                        }
                        <div className="sub-user-table-desktop-header-item-icon" onClick={() => setFieldFilter(item.key)}>
                        {
                            item.order !== false && (
                                <Icon
                                iconClass="arrow-order"
                                name={
                                    item.key === fieldToOrder
                                    ? orderAscending
                                        ? "arrow-up"
                                        : "arrow-down"
                                    : "arrow-down"
                                }
                            />
                            )    
                        }
                        </div>
                    </div>
                )
            })
            }
        </>
    );
}

export default SubUserTableRow;